document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-catfly]").forEach((root) => {
    const items = root.querySelectorAll("[data-catfly-item]");
    const panel = root.closest(".cat-menu__panel");

    const closeAll = () => {
      items.forEach((it) => {
        it.classList.remove("is-open");
        const sub = it.querySelector("[data-catfly-sub]");
        if (sub) sub.setAttribute("aria-hidden", "true");
      });
    };

    const openItem = (it) => {
      closeAll();
      const sub = it.querySelector("[data-catfly-sub]");
      if (!sub) return;

      it.classList.add("is-open");
      sub.setAttribute("aria-hidden", "false");

      // Align submenu bubble to hovered item (like Screenshot_7)
      const itemTop = it.offsetTop;
      const maxTop = panel ? (panel.offsetHeight - sub.offsetHeight - 12) : itemTop;
      const top = Math.max(8, Math.min(itemTop, maxTop));

      sub.style.top = `${top}px`;
    };

    items.forEach((it) => {
      const hasChildren = it.classList.contains("has-children");
      if (!hasChildren) return;

      it.addEventListener("mouseenter", () => openItem(it));
      it.addEventListener("focusin", () => openItem(it));
    });

    // Close on leaving the whole dropdown
    root.addEventListener("mouseleave", closeAll);

    // Close on ESC
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeAll();
    });
  });
});
